import React, { useEffect, useMemo, useState } from 'react';
import { TransactionsNew } from '../../pages';
import { theYear } from '../../utils/utils';
import { TransactionsController } from '../../controllers';
import moment from 'moment';
import { object, string } from 'yup';
import { transactionStore } from '../../stores';
import constant from '../../utils/constant';

const TransactionsNewContainer = () => {
	const [loading, setLoading] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(`${theYear}`);

	const { transactionSummary } = TransactionsController;

	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([
				// transactions(),
				transactionSummary(),
			]);
			setLoading(false);
		};
		setTransactions();
	}, []);

	const validationSchema = () => {
		return object({
			startDate: string().required('Start Date is required'),
			endDate: string().required('End Date is required'),
		});
	};

	//modals

	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			// transactions(),
			transactionSummary(),
			// CustomerController.getCustomers(),
		]);
		setLoading(false);
	};

	//for tables
	const tableTypeConstant = {
		INFLOW: 'INFLOW',
		OUTFLOW: 'OUTFLOW',
	};

	const inflowTagData = [
		{
			key: constant.FLOW_TYPE.All,
			value: 'All Inflow Transactions',
		},
		{
			key: constant.FLOW_TYPE.Income,
			value: 'Income',
		},
		{
			key: constant.FLOW_TYPE.Untagged,
			value: 'Untagged',
		},
		{
			key: constant.FLOW_TYPE.Refund,
			value: 'Refund',
		},
		{
			key: constant.FLOW_TYPE.Funding,
			value: 'Wallet Funding',
		},
		{
			key: constant.FLOW_TYPE.Loan,
			value: 'Loan',
		},
		{
			key: constant.FLOW_TYPE.Investment,
			value: 'Investment',
		},
		{
			key: constant.FLOW_TYPE.Gifts,
			value: 'Gifts And Donations',
		},
		{
			key: constant.FLOW_TYPE.Assets,
			value: 'Sales Of Business Properties',
		},
	];

	const outflowTagData = [
		{
			key: constant.FLOW_TYPE.All,
			value: 'All Outflow Transactions',
		},
		{
			key: constant.FLOW_TYPE.Withdraw,
			value: 'Withdrawal',
		},
		{
			key: constant.FLOW_TYPE.Expense,
			value: 'Expense',
		},
	];

	const [tableType, setTableType] = useState(tableTypeConstant.INFLOW);
	const [showContent, setShowContent] = useState(false);
	const [tagTitle, setTagTitle] = useState(inflowTagData[0].value);
	const [tagKey, setTagKey] = useState(inflowTagData[0].key);

	const tableTypeData = [
		tableTypeConstant.INFLOW,
		tableTypeConstant.OUTFLOW,
	];

	const tableTagData = useMemo(() => {
		if (tableType === tableTypeConstant.INFLOW) {
			return inflowTagData;
		} else if (tableType === tableTypeConstant.OUTFLOW) {
			return outflowTagData;
		} else {
			return inflowTagData;
		}
	}, [tableType]);

	const tableTypeNavHandler = type => {
		setTableType(type);
		if (type === tableTypeConstant.INFLOW) {
			setTagTitle(inflowTagData[0].value);
			setTagKey(inflowTagData[0].key);
		} else if (type === tableTypeConstant.OUTFLOW) {
			setTagTitle(outflowTagData[0].value);
			setTagKey(outflowTagData[0].key);
		}
	};

	const tagContentHandler = () => {
		setShowContent(!showContent);
	};

	const tagSetHandler = item => {
		setTagTitle(item.value);
		setTagKey(item.key);
		tagContentHandler();
	};

	//Update to transaction Table
	const [transactionLimit, setTransactionLimit] = useState(50);
	const [transactionFilterQuery, setTransactionFilterQuery] = useState('');
	const [transactionCurrentPage, setTransactionCurrentPage] = useState(0);
	const [transactionSearchQuery, setTransactionSearchQuery] = useState('');

	const transactionTableQuery = useMemo(() => {
		if (tagKey === constant.FLOW_TYPE.All || tagKey === '') {
			return `offset=${transactionCurrentPage + 1}&limit=${transactionLimit}&type=${tableType}`;
		} else {
			return `offset=${transactionCurrentPage + 1}&limit=${transactionLimit}&type=${tableType}&inflowType=${tagKey}`;
		}
	}, [transactionCurrentPage, transactionLimit, tableType, tagKey]);

	const transactionDataInfo = TransactionsController.useTransactionTypeList(
		transactionTableQuery,
		transactionFilterQuery,
		transactionSearchQuery
	);

	const onTransactionLimitChange = limit => {
		setTransactionLimit(limit);
		setTransactionCurrentPage(0);
	};

	//MODALS
	const modalConstant = {
		close: 'CLOSE',
		viewIncome: 'VIEW-INCOME',
		viewExpense: 'VIEW-EXPENSE',
		tagTransaction: 'TAG-TRANSACTION',
	};

	const [modalType, setModalType] = useState(modalConstant.close);

	const openModalHandler = item => {
		setModalType(item);
	};

	const closeModal = () => {
		setModalType('CLOSE');
	};

	const handleExpenseOptionSelect = (_id, transaction, option) => {
		transactionStore.setSelectedTransaction(transaction);
		if (option.value === 'View More') {
			// setViewMoreExpense(true);
			setModalType(modalConstant.viewExpense);
		}
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=createdAt`;
			setTransactionFilterQuery(query);

			if (payload.period === 'custom') {
				setFilterPeriod(
					`${moment(payload?.startDate).format('DD-MM-YYYY')} - ${moment(payload.endDate).format('DD-MM-YYYY')}`
				);
			} else {
				setFilterPeriod(`${payload?.periodText}`);
			}
		}
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(query),
			// TransactionsController.transactions(query),
		]);

		setLoading(false);
	};

	const resetFilter = () => {
		onSubmit();
		setFilterPeriod(`${theYear}`);
		setTransactionFilterQuery('');
	};

	return (
		<TransactionsNew
			loading={loading}
			filterPeriod={filterPeriod}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			resetFilter={resetFilter}
			tableType={tableType}
			refresh={refresh}
			tableTypeNavHandler={tableTypeNavHandler}
			tableTypeData={tableTypeData}
			tagContentHandler={tagContentHandler}
			tagTitle={tagTitle}
			showContent={showContent}
			tableTagData={tableTagData}
			tagSetHandler={tagSetHandler}
			tableTypeConstant={tableTypeConstant}
			transactionDataInfo={transactionDataInfo}
			onTransactionLimitChange={onTransactionLimitChange}
			transactionLimit={transactionLimit}
			transactionCurrentPage={transactionCurrentPage}
			setTransactionCurrentPage={setTransactionCurrentPage}
			setTransactionSearchQuery={setTransactionSearchQuery}
			modalType={modalType}
			modalConstant={modalConstant}
			openModalHandler={openModalHandler}
			closeModal={closeModal}
			handleExpenseOptionSelect={handleExpenseOptionSelect}
		/>
	);
};

export default TransactionsNewContainer;
